import { z } from 'zod';
const withdrawSelfParamsSchema = z.object({
    shiftId: z.string().uuid(),
    participantId: z.string().uuid(),
    shiftStartTimeMs: z.number(),
    withdrawalAllowedTimeMs: z.number(),
});
export const withdrawSelfFunctionDef = {
    name: 'withdrawSelf',
    requestSchema: withdrawSelfParamsSchema,
    responseSchema: z.void(),
};
